import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { Page } from 'src/app/shared/models/page';
import { Observable, from } from 'rxjs';
import { PagedData } from 'src/app/shared/models/paged-data';

import { HttpParams } from '@angular/common/http';
import { PageParams } from 'src/app/shared/common/Enums';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiUrlConstants } from 'src/app/shared/common/ApiUrlConstants';

@Injectable({
  providedIn: 'root',
})
export class InvoiceListService {
  constructor(
    private webApiService: WebApiService,
    private snack: MatSnackBar
  ) {}

  fetchInvoicesListBySupplierId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchInvoicesListBySupplierId,
      reqBody
    );
  }

  fetchInvoicesListByBuyerId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchInvoicesListByBuyerId,
      reqBody
    );
  }

  fetchInvoiceStatusSummaryBySupplierId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchInvoiceStatusSummaryBySupplierId,
      reqBody
    );
  }

  fetchInvoiceStatusSummaryByBuyerId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchInvoiceStatusSummaryByBuyerId,
      reqBody
    );
  }

  fetchArchivedInvoicesListBySupplierId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchArchivedInvoicesListBySupplierId,
      reqBody
    );
  }

  fetchArchivedInvoicesListByBuyerId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchArchivedInvoicesListByBuyerId,
      reqBody
    );
  }

  invoiceListsOperations(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.invoiceListsOperations,
      reqBody
    );
  }

  exportAllInvoiceListBySupplierId(reqBody: any) {
    const params = new HttpParams().set(
      'supplierId',
      String(reqBody?.supplierId ?? '')
    );
    return this.webApiService.getRequest<any>(
      ApiUrlConstants.exportAllInvoiceListBySupplierId,
      params
    );
  }

  exportAllInvoiceListByBuyerId(reqBody: any) {
    const params = new HttpParams().set(
      'buyerId',
      String(reqBody?.buyerId ?? '')
    );
    return this.webApiService.getRequest<any>(
      ApiUrlConstants.exportAllInvoiceListByBuyerId,
      params
    );
  }

  addInvoicePaymentDetails(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.addInvoicePaymentDetails,
      reqBody
    );
  }

  fetchInvoiceDataById(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchInvoicesListBySupplierId,
      reqBody
    );
  }

  
}
